import { render, staticRenderFns } from "./PlanningStsV2.vue?vue&type=template&id=36b1e0f2&scoped=true"
import script from "./PlanningStsV2.vue?vue&type=script&lang=js"
export * from "./PlanningStsV2.vue?vue&type=script&lang=js"
import style0 from "./PlanningStsV2.vue?vue&type=style&index=0&id=36b1e0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b1e0f2",
  null
  
)

export default component.exports